import axios from 'axios'

// The public namespace, and nothing else. Browsing is public, and this client is
// what keeps it that way: it is where the list and item calls go, it sends no
// token, and it has no interceptor at all -- a refused public request says
// nothing about whether there was a session, so there is nothing here to clear
// and nobody here to send anywhere. `client.ts` is the other half.
//
// It used to send a placeholder `Authorization` header, which no route ever
// asked for and every authenticated request would have had to be taught to
// ignore.
export const publicClient = axios.create({
  baseURL: '/api/public/',
  timeout: 5000,
  headers: { 'Content-Type': 'application/json' }
})

interface ReqBody {
    [key: string]: any
}

export default {
  async fetchResource (url: string) {
    return publicClient.get(url)
      .then(response => response.data)
  },

  async sendResource (url: string, data: ReqBody) {
    return publicClient.post(url, data)
      .then(response => response.data)
  },

  async updateResource (url: string, data: ReqBody) {
    return publicClient.put(url, data)
      .then(response => response.data)
  }
}
